
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogInleftRight100 as ObiThreewayAnalogInleftRight100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-inleft-right-100.js';
 
 
 

 
 export const ObiThreewayAnalogInleftRight100 = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-inleft-right-100',
   elementClass: ObiThreewayAnalogInleftRight100Element,
   events: {
     
   }
  });
 
 